module.exports = __webpack_public_path__ + "media/images/front/home_1_old-71c4cd467278a1a42a54a111620c5ba7.jpg";